import React from 'react';
import { ChevronRightIcon, SparklesIcon, UsersIcon } from 'lucide-react';
import { PhotoCarousel } from './PhotoCarousel';
import { FitBadge } from '../ui/FitBadge';
import { Tag } from '../ui/Tag';
import { formatDate } from '../../utils/format';
import { budgetLabel, slotsLabel } from '../../utils/event';
import type { Fit } from '../../utils/fit';
import type { MusicEvent } from '../../types/marketplace';
interface EventCardFaceProps {
  event: MusicEvent;
  fit: Fit;
  onDetails?: () => void;
}
export function EventCardFace({
  event,
  fit,
  onDetails
}: EventCardFaceProps) {
  return <article className="relative h-full w-full select-none overflow-hidden rounded-lg bg-surface-2 shadow-[0_16px_48px_rgb(0_0_0/0.18)]" data-id="element-698" data-mp="1l1wq78psbmmm">
      <PhotoCarousel photos={event.photos} alt={event.name} data-id="element-699" data-mp="1g2tkdm1zdcdl" />
      <div className="pointer-events-none absolute inset-x-4 top-5 z-10 flex items-start justify-between gap-2" data-id="element-700" data-mp="3mryeuyh4euao">
        {event.featured ? <Tag tone="overlay" icon={<SparklesIcon className="h-3.5 w-3.5" data-id="element-702" data-mp="3eibicxgsrjwb" />} data-id="element-701" data-mp="3hvhpk0y6q9w0">
            Featured
          </Tag> : <span data-id="element-703" data-mp="3ijwsib1y5k2t" />}
        <FitBadge score={fit.score} data-id="element-704" data-mp="3ij57fu5z74qs" />
      </div>

      <div className="absolute inset-x-3 bottom-3 z-10 rounded-md bg-surface/95 p-4 text-ink backdrop-blur-md" data-id="element-705" data-mp="3ihu3nucj5wzo">
        <div className="flex items-start justify-between gap-3" data-id="element-706" data-mp="3nh6qwg7bd62s">
          <div className="min-w-0" data-id="element-707" data-mp="3sbavist3x20p">
            <h3 className="text-[22px] font-bold leading-tight tracking-[-0.01em]" data-id="element-708" data-mp="13f5dmkjxaiw">{event.name}</h3>
            <p className="mt-1 truncate text-sm text-ink-2" data-id="element-709" data-mp="62hz4av2zubk">
              {formatDate(event.date)} · {event.city.split(',')[0]} · {event.distanceKm} km
            </p>
          </div>
          <div className="shrink-0 text-right" data-id="element-710" data-mp="a2ad5338usob">
            <p className="tabular text-lg font-bold leading-tight" data-id="element-711" data-mp="f25416n0ri9d">{budgetLabel(event)}</p>
            <p className="text-xs text-ink-3" data-id="element-712" data-mp="2bw9o1ncgf80h">per act</p>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-1.5" data-id="element-713" data-mp="2gub8ocpj3fe2">
          <Tag tone="brand" data-id="element-714" data-mp="2gut97lj84frs">{event.theme}</Tag>
          <Tag data-id="element-715" data-mp="3k4ypoc39knyb">{slotsLabel(event)}</Tag>
          <Tag icon={<UsersIcon className="h-3.5 w-3.5" data-id="element-717" data-mp="3k5qlno0rwnp4" />} data-id="element-716" data-mp="3k60dlh5dp4xg">{event.capacity.toLocaleString('en-GB')}</Tag>
        </div>
        <button type="button" onClick={onDetails} className="mt-3 flex w-full items-center justify-between gap-3 border-t border-line pt-3 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-718" data-mp="3f8gqdrqpdhtd">
          <span className="truncate text-sm text-ink-2" data-id="element-719" data-mp="6xx2va2wg78b">{fit.reason}</span>
          <span className="flex shrink-0 items-center text-sm font-bold" data-id="element-720" data-mp="20do892ahsfu">
            Details <ChevronRightIcon className="h-4 w-4" data-id="element-721" data-mp="fr8wbj4ys5id" />
          </span>
        </button>
      </div>
    </article>;
}